import StoryblokClient from 'storyblok-js-client'

export const storyblokClient = new StoryblokClient({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_API_KEY,
  cache: {
    clear: 'auto',
    type: 'memory',
  },
})
